class MFRAccordion {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      accordions: ".accordion-item",
      content: ".accordion-content"
    }

    this.init()
  }

  init() {
    this.$accordions = this.$element.find(this.selectors.accordions)

    this.replaceHTML();
  }

  replaceHTML() {
    this.$accordions.each((index, item) => {
      const $item = $(item); // Wrap item in jQuery
      const $body = $item.find(this.selectors.content);
      const content = $body.html(); // Get the full content

      if (!content) return; // Ensure content is not null or undefined

      // Extract content inside ***
      var extractedHtml = content.match(/\*\*\*(.*?)\*\*\*/s);
      if (extractedHtml && extractedHtml[1]) {
        var decodedHtml = $("<div/>").html(extractedHtml[1]).text(); // Decode HTML entities

        // Replace the original ***...*** with the rendered HTML
        $body.html(content.replace(extractedHtml[0], decodedHtml));
      }
    });
  }
}